import { TriangleExclamationFill } from '@gravity-ui/icons';

import IconTile from './IconTile';

type Props = {
  readonly className?: string;
};

const ErrorScene = ({ className }: Props) => (
  <IconTile icon={TriangleExclamationFill} tone="warning" className={className} />
);

export default ErrorScene;
